import { useQuery } from '@apollo/client'
import { LessonValidation } from './query'

const useLessonValidation = (startDateTime, durationInMinutes) => {
  const from = startDateTime?.toISO()
  const to = startDateTime?.plus({ minutes: durationInMinutes }).toISO()

  const { data, loading } = useQuery(LessonValidation, {
    skip: !startDateTime,
    variables: { timespans: [{ from, to }] },
  })

  return {
    warnings: data?.lessonValidation?.warnings || [],
    isAvailable: Boolean(data?.lessonValidation?.isAvailable),
    loading,
  }
}

export default useLessonValidation
